import { render, staticRenderFns } from "./Adm_unidad.vue?vue&type=template&id=e44dbbee"
import script from "./Adm_unidad.vue?vue&type=script&lang=js"
export * from "./Adm_unidad.vue?vue&type=script&lang=js"
import style0 from "./Adm_unidad.vue?vue&type=style&index=0&id=e44dbbee&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports